type LoginContext = {
	color: string;
	description: string;
	iconPath: string;
	link: string;
	title: string;
	viewBox: string;
};

const loginContext: LoginContext = {
	color: '',
	description: '',
	iconPath: '',
	link: '',
	title: '',
	viewBox: '0 0 24 24',
};

const knownContexts = ['leseliste', 'meinForum', 'neuerLogin', 'smart-abo'];

function contextMapper(context: string) {
	if (typeof context === 'undefined' || !context) {
		return;
	}

	switch (context) {
		case 'leseliste':
			loginContext.title = 'Ihre Leseliste immer und überall';
			loginContext.description =
				'Melden Sie sich an, um Inhalte auf Ihre Leseliste zu setzen und auf all Ihren Geräten abzurufen.';

			// TODO: once more loginContext.iconPaths are added, it should be considered to dynamically import them from a separate file
			loginContext.iconPath =
				'M17,18L12,15.82L7,18V5H17M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z';

			// needs to be in this rgb format in order to use rgb() for opacity
			loginContext.color = '232 134 5';
			break;

		case 'meinForum':
			loginContext.title = 'Eigenes Forum eröffnen';
			loginContext.description =
				'Eröffnen Sie ein Forum und diskutieren Sie Ihr Thema mit der Community.';

			// TODO: once more loginContext.iconPaths are added, it should be considered to dynamically import them from a separate file
			loginContext.iconPath =
				'M18 7H21.5C22.325 7 23 7.675 23 8.5V22L20 19H9.5C8.675 19 8 18.325 8 17.5V16H9.5V17.5H20.6L21.5 18.4V8.5H18V7Z M1 3.5C1 2.6675 1.675 2 2.5 2H14.5C14.8978 2 15.2794 2.15804 15.5607 2.43934C15.842 2.72064 16 3.10218 16 3.5V12.5C16 12.8978 15.842 13.2794 15.5607 13.5607C15.2794 13.842 14.8978 14 14.5 14H4L1 17V3.5Z';

			// needs to be in this rgb format in order to use rgb() for opacity
			loginContext.color = '60 131 246';
			break;

		case 'neuerLogin':
			loginContext.title = 'Ein neuer Login kommt in Kürze';
			loginContext.description =
				'Bald wird es noch einfacher, sich bei DER STANDARD anzumelden – auch mit Ihrem Google- oder Apple-Konto.';
			loginContext.link =
				'<a href="https://usabi.li/do/50f4c185f7d3/63f3" target="_blank" rel="noopener noreferrer">Probieren Sie unseren neuen Login aus</a>';

			// needs to be in this rgb format in order to use rgb() for opacity
			loginContext.color = '232 134 5';
			break;

		// TODO Switch other login contexts to kebab-case https://derstandard.atlassian.net/browse/PCM-1624
		case 'smart-abo':
			loginContext.title = 'Voller Durchblick im Forum';
			loginContext.description =
				'Melden Sie sich an, um das Forum uneingeschränkt nutzen zu können.';
			loginContext.iconPath =
				'M180,232a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h80A12,12,0,0,1,180,232Zm40-128a91.51,91.51,0,0,1-35.17,72.35A12.26,12.26,0,0,0,180,186v2a20,20,0,0,1-20,20H96a20,20,0,0,1-20-20v-2a12,12,0,0,0-4.7-9.51A91.57,91.57,0,0,1,36,104.52C35.73,54.69,76,13.2,125.79,12A92,92,0,0,1,220,104Zm-24,0a68,68,0,0,0-69.65-68C89.56,36.88,59.8,67.55,60,104.38a67.71,67.71,0,0,0,26.1,53.19A35.87,35.87,0,0,1,100,184h56.1A36.13,36.13,0,0,1,170,157.49,67.68,67.68,0,0,0,196,104Zm-20.07-5.32a48.5,48.5,0,0,0-31.91-40,12,12,0,0,0-8,22.62,24.31,24.31,0,0,1,16.09,20,12,12,0,0,0,23.86-2.64Z';

			// needs to be in this rgb format in order to use rgb() for opacity
			loginContext.color = '128 0 255';

			loginContext.viewBox = '0 0 256 256';
			break;

		default:
			return;
	}
}

export function renderLoginContext(context: string): string {
	if (!knownContexts.includes(context)) {
		return '';
	}

	contextMapper(context);

	return `
    <style>
    .login-context {
        align-items: center;
        background-color: rgb(${loginContext.color} / 0.1);
        color: var(--theme--on-surface, #222);
        display: flex;
        flex-direction: column;
        padding: 35px 25px 25px 25px;
        text-align: center;
      }

      .login-context .icon {
        background-color: rgb(${loginContext.color} / 0.12);
        border-radius: 100%;
        line-height: 0;
        padding: 15px;
      }

      .login-context svg {
        color: rgb(${loginContext.color});
        height: 24px;
        width: 24px;
      }

      .login-context h1 {
        font: var(--w1-heading);
        margin: 15px 0 5px;
      }

      .login-context p {
        font: var(--w3-info);
        margin: 0;
        opacity: 0.7;
        text-align: center;
      }

      .login-context p + p {
        margin-top: 0.3em;
      }

      .login-context p:has(a) {
        opacity: 1;
      }

      .login-context p a {
        color: inherit;
        font-weight: 500;
      }

      .login-context p a:hover {
        text-decoration: none;
      }

      .login-context p a:focus-visible {
        outline: .1875rem solid var(--theme--on-base);
      }

      @media (min-width: 768px) {
        .login-context h1 {
          font: var(--w3-heading);
        }

        .login-context p  {
          font: var(--w4-info);
        }

        .login-context svg {
          height: 32px;
          width: 32px;
        }
      }
    </style>

    <header class="login-context">
      ${
				loginContext.iconPath
					? `<div class="icon">
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="${loginContext.viewBox}">
          <path fill="currentColor" d="${loginContext.iconPath}" />
        </svg>
      </div>`
					: ''
			}
      <h1>${loginContext.title}</h1>
      <p>${loginContext.description}</p>
      ${loginContext.link ? `<p>${loginContext.link}</p>` : ''}
    </header>
    `.replace(/\s{2,}/g, ''); // makeshift minification, due to lack of proper tooling
}
